import { AgTable } from '@navi/web-ui/lib/components';
import { ICellRendererParams } from 'ag-grid-community';
import { Button } from '@primitives';
import { useNavigate } from 'react-router-dom';
import React, { useState } from 'react';
import Modal from '@cp/components/Modal/Modal';
import ReactJson from 'react-json-view';
import { GenericObject } from '@cp/src/types/CommonConstans';

type StrategiesTableProps = {
  rowData: GenericObject[];
};

const StrategiesTable = ({ rowData }: StrategiesTableProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState<GenericObject>({});

  const columnDefs = [
    {
      headerName: 'Strategy Name',
      field: 'timelineName',
      cellRenderer: 'agGroupCellRenderer'
    },
    {
      headerName: 'Description',
      field: 'description',
      autoHeight: true
    },
    {
      headerName: 'Status',
      field: 'status'
    },
    {
      headerName: 'Action',
      field: '',
      cellRenderer: (params: ICellRendererParams) => (
        <Button
          variant="secondary"
          size="small"
          onClick={() => {
            setIsModalOpen(true);
            setModalContent(params.data);
          }}
        >
          View details
        </Button>
      )
    }
  ];
  return (
    <>
      <AgTable
        defaultColDef={{
          suppressMovable: true,
          wrapText: true
        }}
        gridOptions={{ suppressCellSelection: true }}
        sizeColumnsToFit={true}
        className="strategiesTable"
        rowData={rowData || []}
        columnDefs={columnDefs}
        domLayout="autoHeight"
        style={{
          width: '100%'
        }}
      />
      <Modal
        iconButtonSize="small"
        headerClassName="bg-[#f1f9f9] rounded"
        contentClassName="w-[800px] h-[600px] overflow-auto mx-[20px] my-[20px]"
        visible={isModalOpen}
        header={'Strategy'}
        onClose={() => setIsModalOpen(false)}
      >
        <ReactJson src={modalContent} name={modalContent?.[0]?.name} />
      </Modal>
    </>
  );
};

export default StrategiesTable;
